<template>
  <div class="flex flex-col gap-6 justify-items-center items-center">
    <img :src="image" alt="" style="max-width: 350px;margin: 0% auto;">
    <Typography size="main-xl" class="text-center leading-none text-nowrap">{{title}}!</Typography>
    <div class="w-1/6 h-[0.25rem] bg-red-500 mx-auto"></div>
    <span class="flex flex-col gap-2">
      <Typography size="secondary-book" class="text-center">{{succes_message}}</Typography>
    </span>
    <Button v-if="visit && visit_cta"
            @click="onClickVisit"
            class="h-16 px-10 bg-primary font-bold text-2xl flex items-center justify-center gap-4">
        <span style="font-size: 40pt; font-family: Ravenholm;font-weight: normal !important;">{{visit_cta}}</span>
    </Button>
  </div>
</template>

<script setup>
import Typography from "@/components/common/Typography.vue"
import { ref } from "vue";
import { cmsStore } from "../../stores/cmsStore";
import { useModalsStore } from '../../stores/useModalsStore'

const assetsUrl = useRuntimeConfig().public.assetsUrl
const modalsStore = useModalsStore()
const cms = cmsStore();
const badge = ref(modalsStore.modalPayload?.badge)
const visit = ref(modalsStore.modalPayload?.visit)
const visit_cta = ref(modalsStore.modalPayload?.visit_cta)
const title = ref(modalsStore.modalPayload?.title)
const succes_message = ref(modalsStore.modalPayload?.succes_message)
const logs = ref(modalsStore.modalPayload?.logs)
const image = ref(`${assetsUrl}/${badge.value.image}`)

const onClickVisit = () => {
  if (visit.value) {
    window.open(visit.value, '_blank')
  }
}

const closeModal = () => {
  modalsStore.closeModal()
}
</script>

<style scoped>
</style>
